
import { Mixins, Component, Ref, Prop } from "vue-property-decorator";
import { config, GSAP } from "_core";
import { onResize } from "_mixins";

import HeroSlide from "./HeroSlide.vue";
import { HomePageHeroAlternativeType } from "../../types";

@Component({
  name: "HomeHeroAlternative",
  components: { HeroSlide },
})
export default class HomeHeroAlternative extends Mixins(onResize) {
  @Prop({ required: true }) data: HomePageHeroAlternativeType;
  @Ref() carousel: HTMLElement;
  @Ref() heroSlides!: HeroSlide[];

  rootClass = "c-home-hero-alternative";

  selectedIndex = 0;
  isAnimating = false;

  get blocks() {
    return this.data && this.data.blocks.length ? this.data.blocks : [];
  }

  get offset() {
    return window.innerWidth < config.mobBreakpoint ? 0 : 150;
  }

  mounted() {
    // Trigger the initial animation when the component loads
    this.animateIn();
  }

  animateIn() {
    // GSAP timeline to stagger the HeroSlide elements on load
    const timeline = GSAP.timeline();

    if (this.isMob) {
      timeline.from(
        this.heroSlides.map((el) => el.$el),
        {
          duration: 0.8,
          autoAlpha: 0, // Fade in
          y: "50", // Start slightly lower
          ease: "power3.out",
          stagger: 0.4, // Stagger the appearance of the slides
        }
      );
    } else {
      timeline.from(
        this.heroSlides.map((el) => el.$el),
        {
          duration: 0.8,
          autoAlpha: 0, // Fade in
          y: "-100vh", // Start slightly lower
          ease: "power3.out",
          stagger: 0.4, // Stagger the appearance of the slides
        }
      );
    }
  }

  handlePrev() {
    if (this.isAnimating || this.selectedIndex === 0) return;
    this.isAnimating = true;

    this.selectedIndex -= 1;

    GSAP.to(this.carousel.children[this.selectedIndex], {
      width: window.innerWidth - this.offset,
      clearProps: "width",
      duration: 0.5,
      onComplete: () => {
        this.isAnimating = false;
      },
    });

    this.animateCarousel();
  }

  handleNext() {
    if (this.isAnimating || this.selectedIndex === this.blocks.length - 1)
      return;
    this.isAnimating = true;

    GSAP.to(this.carousel.children[this.selectedIndex], {
      width: this.offset / 2,
      duration: 0.5,
    });

    this.selectedIndex += 1;

    GSAP.to(this.carousel.children[this.selectedIndex], {
      width: window.innerWidth - this.offset,
      clearProps: "width",
      duration: 0.5,
      onComplete: () => {
        this.isAnimating = false;
      },
    });

    this.animateCarousel();
  }

  animateCarousel() {
    const totalBlocks = this.blocks.length;

    let translateX = 0;

    if (this.selectedIndex > 1 && this.selectedIndex < totalBlocks - 1) {
      translateX = -(this.selectedIndex - 1) * (this.offset / 2);
    } else if (this.selectedIndex >= totalBlocks - 1) {
      translateX = -(totalBlocks - 3) * (this.offset / 2);
    }

    GSAP.to(this.carousel, {
      x: translateX,
      ease: "power2.out",
      duration: 0.5,
    });
  }
}
